































import { Component, Vue, Prop } from "vue-property-decorator";

interface RadiusOption {
  label: string;
  value: number;
}

@Component({})
export default class PostcodeArgs extends Vue {
  @Prop() public postcode: string;
  @Prop() public radius: number;
  private radiusOptions: RadiusOption[] = [
    {
      label: "10",
      value: 10
    },
    {
      label: "20",
      value: 20
    },
    {
      label: "30",
      value: 30
    },
    {
      label: "40",
      value: 40
    },
    {
      label: "50",
      value: 50
    },
    {
      label: "60",
      value: 60
    },
    {
      label: "80",
      value: 80
    },
    {
      label: "100",
      value: 100
    }
  ];

  private postcodeUpdated(newValue: string) {
      this.$emit("postcodeChanged", newValue);
  }

  private radiusUpdated(newValue: string) {
      this.$emit("radiusChanged", newValue);
  } 
}
